import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import ChevronRightTwoToneIcon from '@mui/icons-material/ChevronRightTwoTone';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import KeyboardArrowLeftTwoToneIcon from '@mui/icons-material/KeyboardArrowLeftTwoTone';
import SettingsIcon from '@mui/icons-material/Settings';
import { MenuItem, Select } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import dayjs from 'dayjs';
import React from 'react';
import { _BASE_URL } from '../../Config/Constants';
import { TripRoutes } from '../../Config/routes';
import HTTPClient from '../../Utils/HTTPClient';
import Header from '../Includes/Header';
import './trip.css';
import TripCalendar from './TripCalendar';
import TripFilter from './TripFilter';
import TripYearCal from './TripYearCal';
import UserTrip from './UserTrip';
const TripInactive = () => {
  const [singleTrip, setSingleTrip] = React.useState({});
  const [tripList, setTripList] = React.useState([]);
  const [tripListInactive, setTripListInactive] = React.useState([]);
  const [triptypeList, setTriptypeList] = React.useState([]);
  const [calYear, setCalYear] = React.useState(dayjs().year());
  const [calType, setCalType] = React.useState(1);
  const [singleUser, setSingleUser] = React.useState([]);
  const [addTrip, setAddTrip] = React.useState(false);
  const [userList, setUserList] = React.useState([]);
  const [scrollToday, setscrollToday] = React.useState(false);
  const [openLoader, setOpenLoader] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [sortBy, setSortBy] = React.useState('supervisorName');
  const [currentFilter, setCurrentFilter] = React.useState({
    project: [],
    client: [],
    triptype: [],
    pm: [],
    pma: [],
    sortBy: 'supervisorName',
  });
  // const [openLoader,setOpenLoader]=React.useState(false);

  const getTripList = (filter = {}) => {
    setSingleUser([]);
    setOpenLoader(true);
    const _token = sessionStorage.getItem('token');
    let userId = '';
    if (_token) {
      const tokenArr = JSON.parse(_token);
      userId = tokenArr?.emp;
    } else {
      return;
    }
    HTTPClient.post(TripRoutes.getTripInactive + '?year=' + calYear, {
      ...filter,
      userId: userId,
      sortBy: sortBy,
    })
      .then((response) => {
        setCurrentFilter(response.data.filterData);
        setAddTrip(false);
        setTripList(response.data.tripList);
        setTripListInactive(response.data.inactiveList);
        if (response.data.filterData && response.data.filterData?.sortBy) {
          setSortBy(response.data.filterData.sortBy);
          handleSortList(response.data.filterData.sortBy, false, response.data.tripList);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };
  const updateTripFilter = (filter) => {
    HTTPClient.post(TripRoutes.updateTripFilter, {
      filter,
      userId: JSON.parse(sessionStorage.getItem('token'))?.emp,
    })
      .then(() => {
        setCurrentFilter(filter);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSortList = (sortValue, canSave = false, list = tripList) => {
    setSortBy(sortValue);
    //alert("Sorting by " + sortValue);

    let entries = [];

    Object.keys(list).forEach((key) => {
      if (list[key]?.id) {
        const namePart = list[key].name.split(' ')[0] || '';
        const projectPart = list[key].currentProject.replace(/[^a-zA-Z0-9]/g, '') || '';

        // Add dash between project and name for better sorting
        const tempClientKey =
          sortValue === 'supervisorName' ? namePart.replace(/[^a-zA-Z0-9]/g, '') : projectPart;

        const newKey = `${tempClientKey}_${list[key].id}`;

        entries.push({
          sortKey: tempClientKey.toLowerCase(), // for case-insensitive sort
          newKey,
          data: list[key],
        });
      }
    });

    // Sort by sortKey
    entries.sort((a, b) => a.sortKey.localeCompare(b.sortKey));

    // Reconstruct sorted object
    const sortedObj = {};
    entries.forEach((entry) => {
      sortedObj[entry.newKey] = entry.data;
    });

    if (canSave) {
      updateTripFilter({ ...currentFilter, sortBy: sortValue });
    }

    setTripList(sortedObj);
  };

  const getTriptypeList = () => {
    setOpenLoader(true);
    HTTPClient.get(TripRoutes.tripTypesList)
      .then((response) => {
        setTriptypeList(response.data.typeList);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setOpenLoader(false);
      });
  };
  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete?')) {
      const param = { id: id.id };
      HTTPClient.post(TripRoutes.deleteTrip, param)
        .then(() => {
          getTripList({ clearCache: true, newFilter: false });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleEdit = (id) => {
    HTTPClient.get(TripRoutes.getTripById(id))
      .then((response) => {
        // console.log("responseresponse", response);
        if (response.data.trip) {
          setSingleTrip(response.data.trip);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleSingleUser = (user, trip = undefined) => {
    setIsLoading(true);

    HTTPClient.get(TripRoutes.getUserTrips(user.id))
      .then((response) => {
        setSingleUser(response.data.tripList);
        if (trip) {
          let t = response.data.tripList.find((item) => item.id === trip.trip_id);
          setSingleTrip(t);
        } else {
          setSingleTrip(response.data.tripList[0]);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  const applyFilter = (filter) => {
    getTripList({ ...filter, newFilter: true });
  };
  const JSONToCSVConvertor = () => {
    HTTPClient.get(TripRoutes.getTripByIdAndYear(0, calYear) + '?page=0')
      .then((response) => {
        const trRm = [...response.data.tripList];
        const JSONData = [...trRm].map((item) => {
          const mainApprover = userList.find((usr) => usr.id == item.main_approver);
          const secondaryApprover = userList.find((usr) => usr.id == item.secondary_approver);
          return {
            // "Client":item.phone,
            Project: item.projectName,
            Supervisor: item.supervisorName + ' ' + item.supervisorSurname,
            TripType: item.type,
            TravelType: item.travelType,
            FromDate: item.fromDate,
            ToDate: item.toDate,
            MainApprover: mainApprover ? mainApprover.label : '',
            SecondaryApprover: secondaryApprover ? secondaryApprover.label : '',
            TripService: item.serviceName,
            Description: item.description,
            OnwardJourny: item.onwardJourney,
            ReturnJourny: item.returnJourney,
            Country: item.countryName,
          };
        });
        const ReportTitle = '';
        const ShowLabel = true;
        let arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
        let CSV = '';
        CSV += ReportTitle + '';
        if (ShowLabel) {
          let row = '';
          for (let index in arrData[0]) {
            row += index + ',';
          }
          row = row.slice(0, -1);
          CSV += row + '\r\n';
        }
        for (let i = 0; i < arrData.length; i++) {
          let row = '';
          for (let index in arrData[i]) {
            row += '"' + arrData[i][index] + '",';
          }

          row.slice(0, row.length - 1);
          CSV += row + '\r\n';
        }
        if (CSV == '') {
          alert('Invalid data');
          return;
        }
        let fileName = 'MyReport_';
        fileName += ReportTitle.replace(/ /g, '_');
        let uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
        let link = document.createElement('a');
        link.href = uri;
        link.style = 'visibility:hidden';
        link.download = fileName + '.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch(() => {});
  };
  function getUserList() {
    HTTPClient.get(_BASE_URL + '/UserController/getUsers')
      .then((response) => {
        let ustItems = [...response.data.users];
        ustItems = ustItems.sort((a, b) => {
          return a.firstname.localeCompare(b.firstname);
        });
        let cl = ustItems.map((data) => ({
          id: parseInt(data.id),
          value: parseInt(data.id),
          label: data.firstname + ' ' + data.lastname,
          isMainApr: data.approver.includes('1'),
          isSecondaryApr: data.approver.includes('2'),
        }));
        setUserList(cl);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  React.useEffect(() => {
    getTripList({ newFilter: false });
    getUserList();
    getTriptypeList();
  }, []);
  React.useEffect(() => {
    if (calYear) getTripList({ newFilter: false, clearCache: true });
  }, [calYear]);
  return (
    <React.Fragment>
      <Header />
      {openLoader ? (
        <Backdrop sx={{ color: '#fff', zIndex: 10000 }} open={openLoader} className="backdropList">
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        ''
      )}
      <Container maxWidth="100%" className="settings-container" style={{ marginTop: '70px' }}>
        <Grid container>
          <Grid item sm={4}>
            <h3 className="pagehead">Trip Schedules</h3>
          </Grid>
          <Grid item sm={6} className="get_single_op_token alignright">
            <span>
              <TripFilter
                userList={userList}
                applyFilter={applyFilter}
                triptypeList={triptypeList}
                currentFilter={currentFilter}
              />
            </span>
            <span style={{ marginRight: '10px' }}>
              <Select
                value={sortBy}
                onChange={(e) => handleSortList(e.target.value, true)}
                className="_tr_sortby"
                size="small"
                variant="outlined"
                style={{
                  width: '150px',
                  borderRadius: '50px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  height: '40px',
                }}
              >
                <MenuItem value="supervisorName">Sort by supervisor</MenuItem>
                {/* <MenuItem value="clientName">Sort by Project</MenuItem> */}
                <MenuItem value="projectName">Sort by Project</MenuItem>
              </Select>
            </span>
            <span className="_tr_year_block">
              <IconButton
                size="small"
                variant="contained"
                color="primary"
                onClick={() => setCalYear(calYear - 1)}
              >
                <KeyboardArrowLeftTwoToneIcon />
              </IconButton>
              {calYear}
              <IconButton size="small" color="primary" onClick={() => setCalYear(calYear + 1)}>
                <ChevronRightTwoToneIcon />
              </IconButton>
            </span>
            <ButtonGroup aria-label="Disabled elevation buttons" size="small" className="cale">
              <Button
                onClick={() => setCalType(1)}
                variant={calType == 1 ? 'contained' : 'outlined'}
              >
                Month
              </Button>
              <Button
                onClick={() => setCalType(2)}
                variant={calType == 2 ? 'contained' : 'outlined'}
              >
                Year
              </Button>
              {calYear === dayjs().year() ? (
                <Button
                  size={'small'}
                  variant="outlined"
                  color={'secondary'}
                  onClick={() => setscrollToday(!scrollToday)}
                >
                  Today
                </Button>
              ) : null}
            </ButtonGroup>
          </Grid>
          <Grid item sm={2} className="get_single_op_token alignright">
            <IconButton
              className="_tr_add_btn btnmgtop"
              onClick={() => (window.location.href = './triptype')}
              style={{ color: '#1a588c' }}
              fontSize={'large'}
            >
              <SettingsIcon />
            </IconButton>
            <IconButton
              className="_tr_add_btn btnmgtop"
              variant="outlined"
              onClick={() => setAddTrip(true)}
              style={{ color: '#1a588c' }}
              fontSize={'large'}
            >
              <AddBoxRoundedIcon />
            </IconButton>
            <IconButton
              className="_tr_add_btn btnmgtop"
              onClick={JSONToCSVConvertor}
              style={{ color: '#1a588c' }}
              fontSize={'large'}
            >
              <FileDownloadIcon />
            </IconButton>
          </Grid>
          <Grid item sm={12} className={'cal-tripData'}>
            {calType == 1 ? (
              <TripCalendar
                handleSingleUser={handleSingleUser}
                currentYear={calYear}
                tripList={tripList}
                tripTypes={triptypeList}
                scrollToday={scrollToday}
                tripListInactive={tripListInactive}
                userList={userList}
              />
            ) : (
              <TripYearCal
                handleSingleUser={handleSingleUser}
                currentYear={calYear}
                tripList={tripList}
                tripTypes={triptypeList}
                scrollToday={scrollToday}
                tripListInactive={tripListInactive}
                userList={userList}
              />
              // <TripCalendarYear
              // userList={userList}
              //   handleSingleUser={handleSingleUser}
              //   currentYear={calYear}
              //   tripList={tripList}
              //   tripTypes={triptypeList}
              //   tripListInactive={tripListInactive}
              // />
            )}
            {isLoading ? (
              <Backdrop sx={{ color: '#fff' }} open={isLoading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (singleUser && singleUser.length) || addTrip ? (
              <UserTrip
                userList={userList}
                singleTripSelected={singleTrip}
                handleEdit={handleEdit}
                handleDelete={handleDelete}
                getTripList={() => getTripList({ clearCache: true, newFilter: false })}
                triptypeList={triptypeList}
                userTrips={singleUser}
                addTrip={addTrip}
                formActions={'add'}
                currentYear={calYear}
                closeDialog={() => {
                  setSingleUser([]);
                  setAddTrip(false);
                }}
              />
            ) : null}
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default TripInactive;
